import { BasicComponent, InputCheckbox, InputText } from "haxt";

import "./MemberLogin.scss";
import { RouterLink } from "../../@noxtum/router/RouterLink";
import { Session } from "../../@noxtum/session/Session";
import { Router } from "../../@noxtum/router/Router";

const URL = "";

export class MemberLogin extends BasicComponent<{
	page: string;
	parts: string[];
}> {

	email = "";
	password = "";
	remember = false;

	passwordConfirm = "";
	fullName = "";
	affiliation = "";
	address = "";
	agreeTerms = false;

	@BasicComponent.bind()
	async onLogin() {
		let email = this.email;
		let password = this.password;
		let remember = this.remember;

		let returnPath = "/members/area";
		const returnParam = new URLSearchParams(window.location.search).get("return");
		if (returnParam) {
			returnPath = decodeURIComponent(returnParam);
		}

		const response = await fetch(`${URL}/api/accounts/login/`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: email,
				password: password,
			}),
		});

		if (response.ok) {
			let responseData = await response.json();
			let session = responseData.session;

			Session.setToken(session, remember);
			Router.navigate(returnPath);
		} else {
			const errorData = await response.json();
			alert(`Login failed: ${errorData.message || errorData.error || 'Unknown error'}`);
		}
	}

	@BasicComponent.bind()
	async onRegister() {
		let email = this.email;;
		let password = this.password;
		let fullName = this.fullName;
		let affiliation = this.affiliation;
		let address = this.address;

		if (!this.agreeTerms) {
			alert("You must agree to the Terms and Conditions to register.");
			return;
		}

		const response = await fetch(`${URL}/api/accounts/`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: email,
				name: fullName,
				affiliation: affiliation,
				address: address,
				password: password,
			}),
		});

		if (response.ok) {
			alert("Registration successful! Please check your email to verify your account.");
		} else {
			const errorData = await response.json();
			alert(`Registration failed: ${errorData.message || errorData.error || 'Unknown error'}`);
		}
	}

	private token = new URLSearchParams(window.location.search).get('token');
	@BasicComponent.bind()
	async onVerifyEmail() {
		let session = Session.getToken();
		if (!session) {
			alert("You must be logged in to verify your email.");
			return;
		}
		if (!this.token) {
			alert("No token provided for email verification.");
			return;
		}

		const response = await fetch(`${URL}/api/accounts/verify-email/`, {
			method: "POST",
			headers: {
				"Authorization": `Session ${session}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				token: this.token,
			}),
		});

		if (response.ok) {
			alert("Email verification successful! You can now log in.");
		} else {
			const errorData = await response.json();
			alert(`Email verification failed: ${errorData.message || errorData.error || 'Unknown error'}`);
		}
	}
	public render() {
		return (
			<div class="MemberLogin">
				<h2>WIP</h2>
			</div>
		);
	}

	public render2() {
		let page = this.props.parts[0];
		let loggedIn = Session.isLoggedIn();

		if (page === "register") {
			if (loggedIn) {
				return this.renderAlreadyLoggedIn();
			}
			return this.renderRegister();
		} else if (page === "verify-email") {
			if (!this.token) {
				return <div class="MemberLogin">
					<h1>Verify Email</h1>
					<p>Invalid verification link. Token is missing.</p>
				</div>;
			}

			if (loggedIn) {
				return <div class="MemberLogin">
					<h1>Verify Email</h1>
					<button type="button" onClick={this.onVerifyEmail}>Verify Email</button>
				</div>;
			} else {
				return <div class="MemberLogin">
					<h1>Verify Email</h1>
					<p>You must be logged in to verify your email</p>
					<RouterLink href="/members/login" query={{ return: window.location.pathname + window.location.search }}>Go to Login</RouterLink>
				</div>;
			}
		} else if (page === "login") {
			if (loggedIn) {
				return this.renderAlreadyLoggedIn();
			}
			return this.renderLogin();
		} else {
			return <div class="MemberLogin">Invalid Page</div>;
		}
	}
	public renderAlreadyLoggedIn() {
		return (
			<div class="MemberLogin">
				<div class="form">
					<h1>You are already logged in.</h1>
					<RouterLink href="/members/area">Go to Members Area</RouterLink>
				</div>
			</div>
		);
	}

	public renderLogin() {
		return (
			<div class="MemberLogin">
				<div class="form">
					<h1>Login</h1>
					<form>
						<div class="field">
							<InputText type="email" placeholder="Email" $={this.$("email")} required autocomplete="email" />

							<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
								<path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4-8 5-8-5V6l8 5 8-5Z" />
							</svg>
						</div>

						<div class="field">
							<InputText type="password" placeholder="Password" $={this.$("password")} required autocomplete="current-password" />

							<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
								<path d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM10 7a2 2 0 0 1 4 0v2h-4Z" />
							</svg>
						</div>

						<div class="row">
							<label class="check">
								<InputCheckbox type="checkbox" $={this.$("remember")} />
								<span>Remember me</span>
							</label>
							<a class="link" href="#">Forgot password?</a>
						</div>

						<button type="button" onClick={this.onLogin}>Login</button>
					</form>

					<div class="register">
						Don't have an account? <RouterLink href="/members/register">Register</RouterLink>
					</div>
				</div>
			</div>
		);
	}

	public renderRegister() {
		return (
			<div class="MemberLogin">
				<div class="form">
					<h1>Register an Account</h1>

					<div class="field">
						<InputText type="email" placeholder="Email*" $={this.$("email")} required autocomplete="email" />

						<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
							<path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4-8 5-8-5V6l8 5 8-5Z" />
						</svg>
					</div>

					<div class="field">
						<InputText type="password" placeholder="Password*" $={this.$("password")} required autocomplete="new-password" />

						<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
							<path d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM10 7a2 2 0 0 1 4 0v2h-4Z" />
						</svg>
					</div>

					<div class="field">
						<InputText type="password" placeholder="Confirm Password*" $={this.$("passwordConfirm")} required autocomplete="new-password" />

						<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
							<path d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM10 7a2 2 0 0 1 4 0v2h-4Z" />
						</svg>
					</div>

					<div class="field">
						<InputText type="text" placeholder="Full Name*" $={this.$("fullName")} required autocomplete="name" />

						<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
							<path d="M12 12a4.5 4.5 0 1 0-4.5-4.5A4.5 4.5 0 0 0 12 12Zm0 2c-4.4 0-8 2.2-8 5v1h16v-1c0-2.8-3.6-5-8-5Z" />
						</svg>

					</div>

					<div class="field">
						<InputText type="text" placeholder="Professional Affiliation" $={this.$("affiliation")} />

						<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
							<path d="M4 21h16V7a2 2 0 0 0-2-2h-3V3H9v2H6a2 2 0 0 0-2 2Zm2-2v-2h2v2Zm0-4v-2h2v2Zm4 4v-2h2v2Zm0-4v-2h2v2Zm4 4v-2h2v2Zm0-4v-2h2v2Z" />
						</svg>

					</div>

					<div class="field">
						{/* TODO handle address correctly */}
						<InputText type="text" placeholder={`Add\u200Bress`} $={this.$("address")} autocomplete="off" />

						<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
							<path d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5Z" />
						</svg>
					</div>

					<div class="row-center">
						<label class="check">
							<InputCheckbox type="checkbox" $={this.$("agreeTerms")} required autocomplete="agree-terms" />
							<span>I agree to the Terms and Conditions</span>
						</label>
					</div>

					<button type="button" onClick={this.onRegister}>Register</button>

					<div class="register">
						Already have an account? <RouterLink href="/members/login">Login</RouterLink>
					</div>
				</div>
			</div>
		);
	}
}
